import { useTranslation } from 'react-i18next';

import {
    Body1,
    Heading2,
    PhoneNumber,
    Stack,
    Subtitle1,
} from '@myphx-engineering/phx-design-system';

import type { PrescriberInfoFragment } from '../../graphql/generated/graphql';

type PrescriberProps = {
    prescriber: PrescriberInfoFragment;
};

export const Prescriber = ({ prescriber }: PrescriberProps) => {
    const { t } = useTranslation();

    return (
        <Stack gap="sm">
            <Heading2>{t('orderConfirmation.prescriber.header')}</Heading2>
            <Stack gap="sm">
                <Body1>{t('orderConfirmation.prescriber.description')}</Body1>
                <Subtitle1>{prescriber.fullNameWithTitle}</Subtitle1>
                {prescriber.phoneNumber && (
                    <PhoneNumber phone={prescriber.phoneNumber} />
                )}
            </Stack>
        </Stack>
    );
};
